(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.frCa = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    domain: '',
    logo: {
      href: '/fr'
    },
    mainBtn: [{
      text: 'NOUS CONTACTER',
      link: '/fr/service-des-ventes'
    }, {
      text: 'CONNEXION',
      link: ''
    }],
    loginLink: {
      text: 'CONNEXION',
      src: ''
    },
    siteLinks: [{
      title: {
        text: 'PRODUITS'
      },
      list: [{
        text: 'Concur Expense',
        src: '/fr/gestion-notes-de-frais'
      }, {
        text: 'Concur Travel',
        src: '/fr/gestion-deplacements'
      }, {
        text: 'Concur Invoice',
        src: '/fr/factures'
      }, {
        text: 'Concur Travel and Expense',
        src: '/fr/gestion-frais-deplacements-pro'
      }, {
        text: 'Concur Intelligence',
        src: '/fr/concur-intelligence'
      }, {
        text: 'Concur Locate',
        src: '/fr/concur-locate'
      }]
    }, {
      title: {
        text: 'FONCTIONNALITÉS'
      },
      list: [{
        text: 'Saisi des crédits d’impôt',
        src: '/fr/saisi-des-credits-dimpot'
      }, {
        text: 'Application mobile',
        src: '/fr/application-mobile'
      }, {
        text: 'Intégration logicielle',
        src: '/fr/connecteurs-financiers'
      }]
    }, {
      title: {
        text: 'À PROPOS'
      },
      list: [{
        text: 'Choisir Concur',
        src: '/fr/choisir-concur'
      }, {
        text: 'Concur Platform',
        src: '/fr/concur-ecosysteme-integre'
      }, {
        text: 'Connaître les prix',
        src: '/fr/connaitre-les-prix',
        classes: 'call-out'
      }, {
        text: 'Service Des Ventes',
        src: '/fr/service-des-ventes',
        classes: 'call-out'
      }]
    }, {
      title: {
        text: 'RESSOURCES'
      },
      list: [{
        text: 'Politique de confidentialité',
        src: '/fr/politique-confidentialite'
      }, {
        text: 'Démonstration Expense',
        src: '/fr/demonstration-autoguidee-expense/self-guided-demo-expense-fr-ca',
        classes: 'call-out'
      }, {
        text: 'Démonstration Invoice',
        src: '/fr/demonstration-autoguidee-invoice/self-guided-demo-invoice-fr-ca',
        classes: 'call-out'
      }]
    }],
    supportLinks: [{
      text: 'BLOG ANGLAIS',
      href: ''
    }, {
      text: 'NOUS CONTACTER',
      href: '/fr/service-des-ventes'
    }],
    mobileAppText: {
      text: 'GET CONCUR MOBILE APP'
    }
  };
});